/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';

//获取区域列表
export function areaList(param) {
	return request(`${config.server}/api/v1/dms/area/list?${objectSerial(param)}`);
}


//修改区域
/*
*  {
 active (integer, optional): 有效性(1有效0失效) ,
 areaCode (string, optional): 区域编码 ,
 areaPath (string, optional): id路径 ,
 fullPath (string, optional): 全路径 ,
 id (integer, optional): 主键ID ,
 name (string, optional): 区域名称 ,
 parentAreaId (integer, optional): 父id ,
 regionId (string, optional),
 sortOrder (integer, optional): 排序
 }
* */
export function areaModify(param) {
	return request(`${config.server}/api/v1/dms/area/modify`,{
		method: 'post',
		body: param
	});
}


//获所有取子区域--传父区域id
export function allChildren(param) {
	return request(`${config.server}/api/v1/dms/area/treeList?${objectSerial(param)}`);
}


//获下一级取子区域--传父id
export function childrenList(param) {
	return request(`${config.server}/api/v1/dms/area/treeListByParentId?${objectSerial(param)}`);
}

//获取详情
export function areaDetail(param) {
	return request(`${config.server}/api/v1/dms/area/detail?${objectSerial(param)}`);
}


//添加新区域
/*
*  {
 active (integer, optional): 有效性(1有效0失效) ,
 areaCode (string, optional): 区域编码 ,
 areaPath (string, optional): id路径 ,
 fullPath (string, optional): 全路径 ,
 name (string, optional): 区域名称 ,
 parentAreaId (integer, optional): 父id ,
 regionId (string, optional),
 sortOrder (integer, optional): 排序
 }
* */
export function areaAdd(param) {
	return request(`${config.server}/api/v1/dms/area/insert`,{
		method: 'post',
		body: param
	});
}


//删除区域
export function areaDelete(id) {
	return request(`${config.server}/api/v1/dms/area/delete`,{
		method: 'post',
		body: id
	});
}








// WEBPACK FOOTER //
// ./src/service/zone/index.js